/**
 * Created by hanyong.zheng on 2018/12/17.
 */
// import Cookies from 'js-cookie'

const TokenKey = 'loginToken'
const UserIdKey = 'userId'
const redirectUrlKey = 'redirectUrl'

// export function getToken () {
//   return Cookies.get(TokenKey)
// }
//
// export function setToken (token) {
//   return Cookies.set(TokenKey, token)
// }
//
// export function removeToken () {
//   return Cookies.remove(TokenKey)
// }
//
// export function getUserId () {
//   return Cookies.get(UserIdKey)
// }
//
// export function setUserId (userId) {
//   return Cookies.set(UserIdKey, userId)
// }
//
// export function removeUserId () {
//   return Cookies.remove(UserIdKey)
// }
//
// export function getRedirectUrl () {
//   return Cookies.get(redirectUrlKey)
// }
//
// export function setRedirectUrl (redirectUrl) {
//   return Cookies.set(redirectUrlKey, redirectUrl)
// }
//
// export function removeRedirectUrl () {
//   return Cookies.remove(redirectUrlKey)
// }

export function getToken () {
  return localStorage.getItem(TokenKey)
}

export function setToken (token) {
  return localStorage.setItem(TokenKey, token)
}

export function removeToken () {
  return localStorage.removeItem(TokenKey)
}

export function getUserId () {
  return localStorage.getItem(UserIdKey)
}

export function setUserId (userId) {
  return localStorage.setItem(UserIdKey, userId)
}

export function removeUserId () {
  return localStorage.removeItem(UserIdKey)
}

export function getRedirectUrl () {
  return localStorage.getItem(redirectUrlKey)
}

export function setRedirectUrl (redirectUrl) {
  return localStorage.setItem(redirectUrlKey, redirectUrl)
}

export function removeRedirectUrl () {
  return localStorage.removeItem(redirectUrlKey)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js